import { ChangeDetectorRef, Pipe, PipeTransform } from '@angular/core';
import { Subscription } from 'rxjs';

import { ConfigService } from 'app/shared/services';

function interpolate(value: any, params?: Record<string, any> | null): any {
    if (typeof value !== 'string' || !params) {
        return value;
    }

    return value.replace(/{{\s*(\w+)\s*}}/g, (_match, key: string) => {
        const v = params[key];
        return v !== undefined && v !== null ? String(v) : '';
    });
}

@Pipe({
    name: 'config',
    pure: false
})
export class ConfigPipe implements PipeTransform {
    private lastKey?: string;
    private lastParamsSig?: string;
    private lastRawValue: any;
    private lastValue: any;
    private sub?: Subscription;

    constructor(
        private config: ConfigService,
        private cdr: ChangeDetectorRef
    ) { }

    transform(
        key: string,
        params?: Record<string, any> | null,
        fallback?: any
    ): any {
        if (!key) {
            return '';
        }

        const paramsSig = params ? JSON.stringify(params) : '';

        // Si cambia la key, resuscribimos al observable
        if (key !== this.lastKey) {
            this.lastKey = key;
            this.lastParamsSig = paramsSig;

            this.sub?.unsubscribe();
            this.sub = this.config
                .select(key, fallback)
                .subscribe(raw => {
                    this.lastRawValue = raw;
                    this.lastValue = interpolate(this.lastRawValue, params);
                    this.cdr.markForCheck();
                });

            return this.lastValue ?? key;
        }

        // Misma key, pero han cambiado los params -> re-interpolamos
        if (paramsSig !== this.lastParamsSig) {
            this.lastParamsSig = paramsSig;
            this.lastValue = interpolate(this.lastRawValue, params);
            this.cdr.markForCheck();
        }

        return this.lastValue ?? this.config.get(key, fallback);
    }
}
